var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_c('v-date-picker', {
    staticClass: "motto-calendar",
    attrs: {
      "attributes": _vm.calendarAttributes,
      "locale": _vm.calendarOptions.locale,
      "value": null,
      "color": "blue"
    },
    on: {
      "dayclick": _vm.updateDate,
      "update:from-page": _vm.updateMonthAndYear
    },
    model: {
      value: _vm.selectedDate,
      callback: function callback($$v) {
        _vm.selectedDate = $$v;
      },
      expression: "selectedDate"
    }
  }), _c('Tooltip', {
    attrs: {
      "target": "tooltip-button-show-event",
      "placement": "top",
      "custom-class": "calendar-tooltip"
    }
  }, [_c('div', {
    staticClass: "tooltip-item"
  }, [_c('div', {
    staticClass: "calendar-tooltip-color-example calendar-blue"
  }), _c('p', {
    staticClass: "overline-text"
  }, [_vm._v("Network Events")])]), _c('div', {
    staticClass: "tooltip-item"
  }, [_c('div', {
    staticClass: "calendar-tooltip-color-example calendar-green"
  }), _c('p', {
    staticClass: "overline-text"
  }, [_vm._v("Industry Events")])]), _c('div', {
    staticClass: "tooltip-item"
  }, [_c('div', {
    staticClass: "calendar-tooltip-color-example calendar-orange"
  }), _c('p', {
    staticClass: "overline-text"
  }, [_vm._v("Prof. Development/Education")])]), _c('div', {
    staticClass: "tooltip-item"
  }, [_c('div', {
    staticClass: "calendar-tooltip-color-example calendar-gray"
  }), _c('p', {
    staticClass: "overline-text"
  }, [_vm._v("Support Closure")])]), _c('div', {
    staticClass: "tooltip-item"
  }, [_c('div', {
    staticClass: "calendar-tooltip-color-example calendar-dark-blue"
  }), _c('p', {
    staticClass: "overline-text"
  }, [_vm._v("Onboarding and Implementation")])]), _vm.isMottoCorporate ? [_c('div', {
    staticClass: "tooltip-item"
  }, [_c('div', {
    staticClass: "calendar-tooltip-color-example calendar-slate"
  }), _c('p', {
    staticClass: "overline-text"
  }, [_vm._v("Internal Event")])]), _c('div', {
    staticClass: "tooltip-item"
  }, [_c('div', {
    staticClass: "calendar-tooltip-color-example calendar-red"
  }), _c('p', {
    staticClass: "overline-text"
  }, [_vm._v("Communication Calendar")])])] : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }